module.exports = __webpack_public_path__ + "img/fig16.569fd1b9.jpg";